class ErrorController {

  set title (title) {
    this._title = title
  }

  get title () {
    if (this._title) {
      return this._title
    }
    if (!this.error) {
      return null
    }
    const {status} = this.error
    if (status) {
      return `error.${status}.title`
    }
    return 'error.500.title'
  }

  set description (desc) {
    this._description = desc
  }

  get description () {
    if (this._description) {
      return this._description
    }
    if (!this.error) {
      return null
    }
    const {status} = this.error
    if (status) {
      return `error.${status}.description`
    }
    return 'error.500.description'
  }

  get details () {
    const {data} = this.error
    return data
  }
}

export default ErrorController



// WEBPACK FOOTER //
// ./src/app/common/error/error.controller.js